var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile_icon-8",
    "data-name": "Profile icon-8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.945,
    height: 24,
    viewBox: "0 0 20.945 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Profile_icon-8-2",
    "data-name": "Profile icon-8",
    d: "M12,5.259a7.856,7.856,0,0,0-5.891,7.607V18.1a.874.874,0,0,1-.872.873,1.747,1.747,0,0,0-1.746,1.745v1.31a.435.435,0,0,0,.437.435H24a.438.438,0,0,0,.437-.435v-1.31a1.748,1.748,0,0,0-1.746-1.745.871.871,0,0,1-.872-.873V12.866A7.857,7.857,0,0,0,15.93,5.259v-.9a1.964,1.964,0,1,0-3.927,0Zm-1.091,18.08h6.109a3.055,3.055,0,1,1-6.109,0Z",
    transform: "translate(-3.494 -2.394)",
    fill: "#686969",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.154f022eac1ed4c6686a1355b3573d2a.svg";
export { ForwardRef as ReactComponent };